// extracted by mini-css-extract-plugin
module.exports = {"rootTouchBuffer":"Handle_rootTouchBuffer__2gCqJ","visibleHandle":"Handle_visibleHandle__2CQtq","dragged":"Handle_dragged__-PngT"};